import axiosInstance from "../axiosInstance";
import { formatCurrency } from "./currency";

// languages supported in locize
export const communityToCurrencyMap = {
  sg: "sgd",
  my: "myr",
  tw: "twd",
  id: "idr",
  th: "thb",
  vn: "vnd",
  ph: "php",
  kr: "krw",
  jp: "jpy",
  hk: "hkd",
  cn: "cny",
  au: "aud",
  nz: "nzd",
  gb: "gbp",
  eu: "eur",
  ca: "cad",
  us: "usd",
  ch: "chf",
  ae: "aed",
  in: "inr",
  br: "brl",
  ru: "rub",
  za: "zar",
  mx: "mxn",
  ar: "ars",
  cl: "clp",
  co: "cop",
  pe: "pen",
  eg: "egp",
  ng: "ngn",
  ke: "kes",
  il: "ils",
  sa: "sar",
  qa: "qar",
  bh: "bhd",
  kw: "kwd",
  om: "omr",
  pk: "pkr",
  bd: "bdt",
  np: "npr",
  lk: "lkr",
  mm: "mmk", // Myanmar (Burma)
  kh: "khr", // Cambodia
  la: "lak", // Laos
  bn: "bnd", // Brunei
  mo: "mop", // Macau
  mn: "mnt", // Mongolia
  uz: "uzs", // Uzbekistan
  kz: "kzt", // Kazakhstan
  kg: "kgs", // Kyrgyzstan
  tj: "tjs", // Tajikistan
  tm: "tmt", // Turkmenistan
  af: "afn", // Afghanistan
  fr: "eur",
  de: "eur",
  it: "eur",
  es: "eur",
  pt: "eur",
  nl: "eur",
  be: "eur",
  at: "eur",
  fi: "eur",
  gr: "eur",
  ie: "eur",
  no: "nok",
  se: "sek",
  dk: "dkk",
  pl: "pln",
  cz: "czk",
  hu: "huf",
  tr: "try",
  ua: "uah",
  is: "isk",
  ro: "ron",
  bg: "bgn",
  hr: "hrk",
  rs: "rsd",
  si: "eur",
  sk: "eur",
  lt: "eur",
  lv: "eur",
  ee: "eur",
  cy: "eur",
  mt: "eur",
  lu: "eur",
  ma: "mad",
  dz: "dzd",
  tn: "tnd",
  ly: "lyd",
};

export const currencyToCreditsGiftMap = {
  sgd: {
    survey: 5,
    welcome: 20,
    first: 10,
    second: 20,
    third: 40,
  },
  myr: {
    survey: 10,
    welcome: 60,
    first: 30,
    second: 60,
    third: 120,
  },
  twd: {
    survey: 100,
    welcome: 500,
    first: 250,
    second: 500,
    third: 1000,
  },
  idr: {
    survey: 50000,
    welcome: 200000,
    first: 100000,
    second: 200000,
    third: 400000,
  },
  thb: {
    survey: 100,
    welcome: 500,
    first: 250,
    second: 500,
    third: 1000,
  },
  vnd: {
    survey: 80000,
    welcome: 320000,
    first: 160000,
    second: 320000,
    third: 640000,
  },
  php: {
    survey: 200,
    welcome: 800,
    first: 400,
    second: 800,
    third: 1600,
  },
  krw: {
    survey: 5000,
    welcome: 20000,
    first: 10000,
    second: 20000,
    third: 40000,
  },
  jpy: {
    survey: 500,
    welcome: 2000,
    first: 1000,
    second: 2000,
    third: 4000,
  },
  hkd: {
    survey: 30,
    welcome: 120,
    first: 60,
    second: 120,
    third: 240,
  },
  cny: {
    survey: 25,
    welcome: 100,
    first: 50,
    second: 100,
    third: 200,
  },
  aud: {
    survey: 5,
    welcome: 20,
    first: 10,
    second: 20,
    third: 40,
  },
  nzd: {
    survey: 5,
    welcome: 20,
    first: 10,
    second: 20,
    third: 40,
  },
  gbp: {
    survey: 5,
    welcome: 15,
    first: 10,
    second: 15,
    third: 30,
  },
  eur: {
    survey: 5,
    welcome: 15,
    first: 10,
    second: 15,
    third: 30,
  },
  cad: {
    survey: 5,
    welcome: 20,
    first: 10,
    second: 20,
    third: 40,
  },
  usd: {
    survey: 5,
    welcome: 15,
    first: 10,
    second: 15,
    third: 30,
  },
  chf: {
    survey: 5,
    welcome: 15,
    first: 10,
    second: 15,
    third: 30,
  },
  aed: {
    survey: 10,
    welcome: 50,
    first: 25,
    second: 50,
    third: 100,
  },
  inr: {
    survey: 250,
    welcome: 1000,
    first: 500,
    second: 1000,
    third: 2000,
  },
  brl: {
    survey: 15,
    welcome: 60,
    first: 30,
    second: 60,
    third: 120,
  },
  rub: {
    survey: 300,
    welcome: 1200,
    first: 600,
    second: 1200,
    third: 2400,
  },
  zar: {
    survey: 50,
    welcome: 200,
    first: 100,
    second: 200,
    third: 400,
  },
  mxn: {
    survey: 50,
    welcome: 200,
    first: 100,
    second: 200,
    third: 400,
  },
  ars: {
    survey: 1000,
    welcome: 4000,
    first: 2000,
    second: 4000,
    third: 8000,
  },
  clp: {
    survey: 2500,
    welcome: 10000,
    first: 5000,
    second: 10000,
    third: 20000,
  },
  cop: {
    survey: 10000,
    welcome: 40000,
    first: 20000,
    second: 40000,
    third: 80000,
  },
  pen: {
    survey: 10,
    welcome: 40,
    first: 20,
    second: 40,
    third: 80,
  },
  egp: {
    survey: 100,
    welcome: 400,
    first: 200,
    second: 400,
    third: 800,
  },
  ngn: {
    survey: 1500,
    welcome: 6000,
    first: 3000,
    second: 6000,
    third: 12000,
  },
  kes: {
    survey: 400,
    welcome: 1600,
    first: 800,
    second: 1600,
    third: 3200,
  },
  ils: {
    survey: 10,
    welcome: 40,
    first: 20,
    second: 40,
    third: 80,
  },
  sar: {
    survey: 10,
    welcome: 40,
    first: 20,
    second: 40,
    third: 80,
  },
  qar: {
    survey: 10,
    welcome: 40,
    first: 20,
    second: 40,
    third: 80,
  },
  bhd: {
    survey: 1,
    welcome: 4,
    first: 2,
    second: 4,
    third: 8,
  },
  kwd: {
    survey: 1,
    welcome: 4,
    first: 2,
    second: 4,
    third: 8,
  },
  omr: {
    survey: 1,
    welcome: 4,
    first: 2,
    second: 4,
    third: 8,
  },
  pkr: {
    survey: 1000,
    welcome: 4000,
    first: 2000,
    second: 4000,
    third: 8000,
  },
  bdt: {
    survey: 500,
    welcome: 2000,
    first: 1000,
    second: 2000,
    third: 4000,
  },
  npr: {
    survey: 400,
    welcome: 1600,
    first: 800,
    second: 1600,
    third: 3200,
  },
  lkr: {
    survey: 1000,
    welcome: 4000,
    first: 2000,
    second: 4000,
    third: 8000,
  },
  mmk: {
    survey: 10000,
    welcome: 40000,
    first: 20000,
    second: 40000,
    third: 80000,
  },
  khr: {
    survey: 12000,
    welcome: 48000,
    first: 24000,
    second: 48000,
    third: 96000,
  },
  lak: {
    survey: 50000,
    welcome: 200000,
    first: 100000,
    second: 200000,
    third: 400000,
  },
  bnd: {
    survey: 4,
    welcome: 16,
    first: 8,
    second: 16,
    third: 32,
  },
  mop: {
    survey: 25,
    welcome: 100,
    first: 50,
    second: 100,
    third: 200,
  },
  mnt: {
    survey: 10000,
    welcome: 40000,
    first: 20000,
    second: 40000,
    third: 80000,
  },
  uzs: {
    survey: 35000,
    welcome: 140000,
    first: 70000,
    second: 140000,
    third: 280000,
  },
  kzt: {
    survey: 1500,
    welcome: 6000,
    first: 3000,
    second: 6000,
    third: 12000,
  },
  kgs: {
    survey: 250,
    welcome: 1000,
    first: 500,
    second: 1000,
    third: 2000,
  },
  tjs: {
    survey: 35,
    welcome: 140,
    first: 70,
    second: 140,
    third: 280,
  },
  tmt: {
    survey: 10,
    welcome: 40,
    first: 20,
    second: 40,
    third: 80,
  },
  afn: {
    survey: 250,
    welcome: 1000,
    first: 500,
    second: 1000,
    third: 2000,
  },
  nok: {
    survey: 30,
    welcome: 150,
    first: 80,
    second: 150,
    third: 300,
  },
  sek: {
    survey: 30,
    welcome: 150,
    first: 80,
    second: 150,
    third: 300,
  },
  dkk: {
    survey: 20,
    welcome: 100,
    first: 50,
    second: 100,
    third: 200,
  },
  pln: {
    survey: 12,
    welcome: 60,
    first: 30,
    second: 60,
    third: 120,
  },
  czk: {
    survey: 70,
    welcome: 350,
    first: 175,
    second: 350,
    third: 700,
  },
  huf: {
    survey: 1000,
    welcome: 5000,
    first: 2500,
    second: 5000,
    third: 10000,
  },
  try: {
    survey: 80,
    welcome: 400,
    first: 200,
    second: 400,
    third: 800,
  },
  uah: {
    survey: 100,
    welcome: 500,
    first: 250,
    second: 500,
    third: 1000,
  },
  isk: {
    survey: 400,
    welcome: 2000,
    first: 1000,
    second: 2000,
    third: 4000,
  },
  ron: {
    survey: 15,
    welcome: 75,
    first: 40,
    second: 75,
    third: 150,
  },
  bgn: {
    survey: 5,
    welcome: 25,
    first: 15,
    second: 25,
    third: 50,
  },
  hrk: {
    survey: 20,
    welcome: 100,
    first: 50,
    second: 100,
    third: 200,
  },
  rsd: {
    survey: 300,
    welcome: 1500,
    first: 750,
    second: 1500,
    third: 3000,
  },
  mad: {
    survey: 30,
    welcome: 150,
    first: 75,
    second: 150,
    third: 300,
  },
  dzd: {
    survey: 400,
    welcome: 2000,
    first: 1000,
    second: 2000,
    third: 4000,
  },
  tnd: {
    survey: 10,
    welcome: 50,
    first: 25,
    second: 50,
    third: 100,
  },
  lyd: {
    survey: 15,
    welcome: 75,
    first: 40,
    second: 75,
    third: 150,
  },
};

export const convertIsoToExtended = (locale) => {
  const isoToExtendedMap = {
    "zh-CN": "zh-Hans-CN", // Simplified Chinese (China)
    "zh-SG": "zh-Hans-CN", // Simplified Chinese (Singapore)
    "zh-MY": "zh-Hans-CN", // Simplified Chinese (Malaysia)
    "zh-TW": "zh-Hant-TW", // Traditional Chinese (Taiwan)
    "zh-HK": "zh-Hant-TW", // Traditional Chinese (Hong Kong)
    "zh-MO": "zh-Hant-TW", // Traditional Chinese (Macau)
    zh: "zh-Hans-CN", // fall back to simple chinese
    en: "en", // English
    ms: "ms", // Malay
    id: "en", // Indonesian
  };

  // If exact match exists, return mapped value
  if (isoToExtendedMap[locale]) {
    return isoToExtendedMap[locale];
  }

  // Try matching just the language code
  const languageCode = locale.split("-")[0];
  if (isoToExtendedMap[languageCode]) {
    return isoToExtendedMap[languageCode];
  }

  // Default to English if no match found
  return "en";
};

export function getReferralAmount(currency, tier, defaultValue) {
  const referralAmount = getReferralAmountWithoutCurrency(
    currency,
    tier,
    defaultValue
  );

  if (!referralAmount) {
    return undefined;
  }

  return formatCurrency(referralAmount);
}

export function getReferralAmountWithoutCurrency(currency, tier, defaultValue) {
  const referralAmount =
    currencyToCreditsGiftMap[currency]?.[tier] || defaultValue;

  return referralAmount;
}

export async function detectUserLocale() {
  // if user is logged in, get from backend
  if (localStorage.getItem("USER_ID") && localStorage.getItem("JWT_TOKEN")) {
    return await computeUserLocale();
  }

  const cached = {
    language: localStorage.getItem("locale"),
    community: localStorage.getItem("community"),
    currency: localStorage.getItem("currency"),
  };

  if (cached.language && cached.community && cached.currency) {
    return cached;
  }

  return await computeUserLocale();
}

async function computeUserLocale() {
  let userLocale;
  let userCommunity;
  let userCurrency;

  try {
    if (localStorage.getItem("USER_ID") && localStorage.getItem("JWT_TOKEN")) {
      const res = await axiosInstance.get("/v1/user/getUserById", {
        params: { user_id: localStorage.getItem("USER_ID") },
      });

      const user = res.data;
      userLocale = user?.preferred_language;
      userCommunity = user?.community;
      userCurrency = user?.currency;
    }

    if (!userCommunity || !userCurrency) {
      const response = await fetch(`https://ipwho.is`);
      const data = await response.json();

      if (data.country_code) {
        if (!userCommunity) {
          userCommunity = data.country_code?.toLowerCase();
        }
        if (!userCurrency) {
          userCurrency = communityToCurrencyMap[userCommunity];
        }
      }
    }

    if (userCommunity && userCurrency) {
      localStorage.setItem("community", userCommunity);
      localStorage.setItem("currency", userCurrency);
    }

    const finalLocale =
      userLocale ||
      convertIsoToExtended(navigator.language || navigator.userLanguage) ||
      "en";

    localStorage.setItem("locale", finalLocale);

    return {
      language: finalLocale,
      community: userCommunity || "sg",
      currency: userCurrency || "sgd",
    };
  } catch (err) {
    console.error("Locale detection failed", err);
    return { language: "en", community: "us", currency: "usd" };
  }
}
